namespace GeniuzPOS.Purchase {
    export interface ListAppCnrtvRow {
        SendForAppfg?: sendapp;
        WaitLv?: number;
        WaitApprove?: string;
        SysDocNo?: string;
        ItemTypeFg?: POTypeFg;
        SupplierId?: string;
        NetTotalInVat?: number;
        CreditNoteNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        LastApprove?: string;
        ApproveDate?: string;
        ShipId?: string;
        Remark?: string;
    }

    export namespace ListAppCnrtvRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'WaitApprove';
        export const localTextPrefix = 'Purchase.ListAppCnrtv';
        export const lookupKey = 'Purchase.ListAppCnrtv';

        export function getLookup(): Q.Lookup<ListAppCnrtvRow> {
            return Q.getLookup<ListAppCnrtvRow>('Purchase.ListAppCnrtv');
        }
        export const deletePermission = '5Purchase:ใบลดหนี้(CNRTV):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบลดหนี้(CNRTV):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบลดหนี้(CNRTV):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบลดหนี้(CNRTV):อนุมัติ:Modify';

        export declare const enum Fields {
            SendForAppfg = "SendForAppfg",
            WaitLv = "WaitLv",
            WaitApprove = "WaitApprove",
            SysDocNo = "SysDocNo",
            ItemTypeFg = "ItemTypeFg",
            SupplierId = "SupplierId",
            NetTotalInVat = "NetTotalInVat",
            CreditNoteNo = "CreditNoteNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            LastApprove = "LastApprove",
            ApproveDate = "ApproveDate",
            ShipId = "ShipId",
            Remark = "Remark"
        }
    }
}
